export const subPageNavigationMessageMap = {
	profile: {
		account: "User Profile",
		tutoring: "Tutoring",
		groups: "Groups",
		financials: "Financials"
	}
};